import(/* webpackMode: "eager" */ "/vercel/path0/app/about/page.tsx");
